import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0034',
    ecrans: ['00-2'],
    params: ['id',
            '?prucleint',
            '?vaesysnatctb',
            '?peccleintdeb',
            '?peccleintfin',
            '?indcleint']
});
